// firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyBtzoYfSN2qJc2FQDHLIw6m0eTlXyhoMIo",
    authDomain: "ddabroad-dae69.firebaseapp.com",
    projectId: "ddabroad-dae69",
    storageBucket: "ddabroad-dae69.firebasestorage.app",
    messagingSenderId: "33721035101",
    appId: "1:33721035101:web:29f3d9471c0df45da960b4"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
